export const WORK = 'WORK';

export function storeData(data) {
  return {
    type: data.actionType,
    payload: data,
  };
}
